import React, { createContext, useContext, useState, useCallback } from "react";
import { getStoredUser, saveSession, clearSession } from "../utils/authStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Session is namespaced per portal (admin vs client) — see utils/authStorage.
  const [user, setUser] = useState(() => getStoredUser());

  const login = useCallback((userData, token) => {
    saveSession(userData, token);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    clearSession();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
